import { prefetchRouteOnIntent } from '../utils/routePrefetch';
import {
  loadInsightsDebtOptimizerScreen,
  loadInsightsScreen,
} from './insightsRouteBundles';

export { loadInsightsDebtOptimizerScreen, loadInsightsScreen };

export const loadExpenseTracker = () => import('../ExpenseTracker');
export const loadTransactionsScreen = () => import(
  /* webpackChunkName: "desktop-financial-tools" */ '../screens/desktop/TransactionsScreen'
);
export const loadBudgetsScreen = () => import(
  /* webpackChunkName: "desktop-financial-tools" */ '../screens/desktop/BudgetsScreen'
);
export const loadCategoriesScreen = () => import(
  /* webpackChunkName: "desktop-financial-tools" */ '../screens/desktop/CategoriesScreen'
);
export const loadIncomeScreen = () => import(
  /* webpackChunkName: "desktop-financial-tools" */ '../screens/desktop/IncomeScreen'
);
export const loadReportsScreen = () => import(
  /* webpackChunkName: "desktop-financial-tools" */ '../screens/desktop/ReportsScreen'
);
export const loadAccountsScreen = () => import(
  /* webpackChunkName: "desktop-account-tools" */ '../screens/desktop/AccountsScreen'
);
export const loadHouseholdScreen = () => import(
  /* webpackChunkName: "desktop-account-tools" */ '../screens/desktop/HouseholdScreen'
);
export const loadNetWorthScreen = () => import(
  /* webpackChunkName: "desktop-account-tools" */ '../screens/desktop/NetWorthScreen'
);
export const loadSettingsScreen = () => import(
  /* webpackChunkName: "desktop-account-tools" */ '../screens/desktop/SettingsScreen'
);

export const DESKTOP_ROUTE_LOADERS = Object.freeze({
  dashboard: loadExpenseTracker,
  transactions: loadTransactionsScreen,
  budgets: loadBudgetsScreen,
  'net-worth': loadNetWorthScreen,
  insights: loadInsightsScreen,
  reports: loadReportsScreen,
  categories: loadCategoriesScreen,
  accounts: loadAccountsScreen,
  household: loadHouseholdScreen,
  settings: loadSettingsScreen,
});

export const prefetchDesktopRoute = (routeKey) => {
  const load = DESKTOP_ROUTE_LOADERS[routeKey];
  if (!load) return Promise.resolve(false);
  return prefetchRouteOnIntent({ routeKey, load });
};
